import { filterShopInventoryForMode } from './shopOrderType';

/** Map public inventory items for ModelPicker / wholesale line builders (no prices). */
export function mapPublicItemToPickerItem(item) {
  return {
    _id: String(item.id),
    id: item.id,
    modelName: item.modelName,
    modelNameMr: item.modelNameMr,
    modelNameKn: item.modelNameKn,
    modelNumber: item.modelNumber,
    currentStock: item.currentStock,
    size: item.size ?? item.category,
    photo: item.photo,
    retailOnly: item.retailOnly,
    isAvailable: (item.currentStock ?? 0) > 0,
  };
}

export function mapPublicInventoryToPickerInventory(items) {
  return filterShopInventoryForMode(items, 'wholesale').map(mapPublicItemToPickerItem);
}

export function buildInventoryById(items) {
  return Object.fromEntries(items.map((item) => [String(item.id), item]));
}

/** Convert bucket lines to public shop cart items for inquiry APIs. */
export function wholesaleLinesToShopCart(lines, publicInventoryById) {
  return lines.map((line) => {
    const inv = publicInventoryById[line.model];
    if (!inv) {
      return null;
    }
    return {
      ...inv,
      id: inv.id,
      quantity: line.qty,
      customRequest: line.colorRequest?.trim() || '',
      advanceAmount: 0,
      customerName: '',
      phone: '',
      deliveryDate: '',
    };
  }).filter(Boolean);
}

export function getWholesaleLinesTotalQty(lines) {
  return lines.reduce((sum, line) => sum + (line.qty || 0), 0);
}
